import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand & Quote */}
          <div className="lg:col-span-1">
            <h3 className="text-2xl font-bold text-white mb-4">相信世代</h3>
            <p className="text-xl italic text-teal-400 mb-6 font-serif">
              “ 凝聚相信的力量，共創正向影響力 ”
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-teal-600 transition-colors">
                <SafeIcon name="Facebook" className="text-white" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-teal-600 transition-colors">
                <SafeIcon name="Instagram" className="text-white" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-teal-600 transition-colors">
                <SafeIcon name="Youtube" className="text-white" />
              </a>
            </div>
          </div>

          {/* Sitemap */}
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider">Sitemap</h4>
            <ul className="space-y-3">
              {['關於我們', '藝術x再生', '影響力學習', '青年公寓', '影響力故事', '公開徵信'].map(item => (
                <li key={item}>
                  <Link to="/" className="hover:text-teal-400 transition-colors">{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Donation */}
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider">捐款支持 Donation</h4>
            <div className="bg-gray-800 p-4 rounded-lg space-y-2 text-sm">
              <p><span className="text-gray-400">戶名：</span><br/>社團法人台灣相信世代發展協會</p>
              <p><span className="text-gray-400">銀行：</span><br/>國泰世華 民權分行（013）</p>
              <p><span className="text-gray-400">帳號：</span><br/><span className="text-teal-400 font-mono text-base">019-03-002484-5</span></p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider">聯絡我們 Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <SafeIcon name="MapPin" className="text-teal-400 mt-1 flex-shrink-0" />
                <span>台北市松山區民權東路三段153巷4弄3號</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon name="Mail" className="text-teal-400 flex-shrink-0" />
                <a href="mailto:Support@binnextgen.org" className="hover:text-teal-400 transition-colors">Support@binnextgen.org</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
          <p>© {new Date().getFullYear()} 相信世代 Binnextgen. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/" className="hover:text-white">隱私權政策</Link>
            <Link to="/" className="hover:text-white">服務條款</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;